import Token from './token'
import Form from './form'

export default {
  svg: 'clock',
  label: 'Wait',
  type: 'control',
  action: 'wait',
  form: Form,
  token: Token
}
